module.exports = __webpack_public_path__ + "img/stretching.e90cccd8.jpg";